import { db } from "../../../firebase"; // Importa la configuración de Firebase
import { collection, addDoc, updateDoc, deleteDoc, doc, getDocs } from "firebase/firestore";

// Referencia a la colección en Firestore
const documentosCollection = collection(db, "TipoDocumento");

// Obtener todos los documentos
const getDocumento = async () => {
  try {
    const querySnapshot = await getDocs(documentosCollection);
    const documentos = querySnapshot.docs.map((doc) => ({
      id: doc.id, // Incluye el ID del documento
      ...doc.data(), // Incluye los datos del documento
    }));
    return documentos;
  } catch (error) {
    console.error("Error al obtener los documentos:", error);
    throw error;
  }
};

// Insertar un nuevo documento
const insertarDocumento = async (documento) => {
  try {
    const { id, ...documentoSinId } = documento; // Excluye el id si existe
    const docRef = await addDoc(documentosCollection, documentoSinId); // Inserta en Firestore
    return { id: docRef.id, ...documentoSinId }; // Retorna el documento con el id generado
  } catch (error) {
    console.error("Error al insertar documento:", error);
    throw error;
  }
};

// Actualizar un documento existente
const actualizarDocumento = async (documento) => {
  try {
    const { id, ...data } = documento; // Extrae el ID del documento y los demás campos
    const docRef = doc(db, "TipoDocumento", id);
    await updateDoc(docRef, data); // Actualiza los datos en Firestore
    console.log(`Documento con ID ${id} actualizado.`);
  } catch (error) {
    console.error("Error al actualizar documento:", error);
    throw error;
  }
};

// Eliminar un documento
const eliminarDocumento = async (id) => {
  try {
    const docRef = doc(db, "TipoDocumento", id); // "documentos" es la colección en Firestore
    await deleteDoc(docRef);
    console.log(`Documento con ID ${id} eliminado.`);
  } catch (error) {
    console.error("Error al eliminar documento:", error);
    throw error;
  }
};

export { getDocumento, insertarDocumento, actualizarDocumento, eliminarDocumento };
